export const formatPrice = price => {
  const parts = price.split('.');

  if (parts.length > 1) {
    return parts[1].length > 1 ? `$${price}` : `$${price}0`;
  }

  return `$${price}`;
};
